<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <div v-show="!multipleChoiceSingleAnswer && !multipleChoiceMultipleAnswers && !freeText && !tableType && !dragAndDrop && !upload" >
      <div class="w-full">
        <vs-table ref="quizTable" v-show="!isQuizListHidden" v-model="selected" class="vs-con-loading__container" single @selected="handleSelectedQuiz" pagination :max-items="itemsPerPage" search :data="quizzes">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center">
              <!-- ADD NEW -->
              <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span class="ml-2 text-base text-primary">Add New</span>
              </div>
            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ quizzes.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : quizzes.length }} of {{ quizzes.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th></vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="isGraded">Type</vs-th>
            <vs-th sort-key="timeLimit">Time Limit</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

              <vs-td>
                <img src="../../assets/images/quiz.png" style="height: 60px">
              </vs-td>

              <vs-td :data="data[indextr].name">
                <p class="product-name font-medium">{{ tr.name }}</p>
              </vs-td>

              <vs-td :data="data[indextr].isGraded">
                <p class="product-name font-medium">{{ tr.isGraded == true ? "Graded" : "Survey" }}</p>
              </vs-td>

              <vs-td :data="data[indextr].timeLimit">
                <p class="product-name font-medium">{{ tr.timeLimit > 0 ? tr.timeLimit + " Minutes" : "Unlimited" }}</p>
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                <p class="product-name font-medium">{{ tr.modifiedOn.replace("T", " ").split('.')[0] }}</p>
              </vs-td>

              <vs-td :data="data[indextr].modifiedBy">
                <p class="product-name font-medium">{{ tr.modifiedBy }}</p>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
      <vx-card id="quizInfoCard" ref="quizInfo" v-show="!isInfoHidden">
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Name</label>
            <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Name" v-model="formData.name" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Title</label>
            <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'max:128'" name="Title" v-model="formData.title" />
            <span class="text-danger text-sm" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3">
          <div class="vx-col w-full mb-2">
            <label>Description</label>
            <quill-editor v-model="formData.description" :options="editorOption"/>   <!-- :options="editorOption" -->
          </div>
        </div>
        <div  class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <label>Type</label>
            <div class="mt-1">
              <vs-radio color="success" v-model="formData.gradeType" vs-value="graded" :disabled="questions.length > 0">Graded</vs-radio>
              <vs-radio class="ml-4" color="success" v-model="formData.gradeType" vs-value="survey" :disabled="questions.length > 0">Survey</vs-radio>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label>Time Limit</label>
            <div>
              <small>Leave 0 (zero) for unlimited time</small>
            </div>
            <div>
              <vs-input-number label="Minutes:" class="numberinput" min="0" v-model="formData.timeLimit" :step="5" icon-inc="expand_less" icon-dec="expand_more" />
            </div>
          </div>
          </div>
        <div class="vx-row"> 
          <div class="vx-col sm:w-1/2 w-full pb-3">
            <div>
              <vs-checkbox color="success" v-model="formData.answerRequired">Answer Required?</vs-checkbox>
            </div>
          </div>  
        </div>        
        <div v-show="formData.gradeType == 'graded'" class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mt-2">
            <label>Pass Percentage</label>
            <div>
              <vs-input-number color="success" label="%:" class="numberinput" min="0" v-model="formData.passPercentage" :step="5" />
            </div>
          </div>
        </div>
        <div v-show="formData.gradeType == 'survey'" class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mt-2">
            <vs-checkbox v-model="formData.isJournal">Is Journal</vs-checkbox>
          </div>
        </div>
        <div class="vx-row mt-4" v-show="questions.length > 0 && !formData.isJournal">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-checkbox v-model="randomize">Randomize Questions</vs-checkbox>
          </div>
        </div>

        <div class="vx-row mt-4" v-for="(classification, index) in classifications" v-show="randomize && !formData.isJournal" :key="index">
          <div class="vx-col sm:w-1/2 w-full">
            <div v-if="classification.className">
              <label>{{classification.className}}</label>
              <div>
                <vs-input-number class="numberinput" min="0" :max="classification.max" v-model="formData.questionClassifications.filter(function (item) { return item.questionClassificationId == classification.id; }).length == 0 ? temp:formData.questionClassifications.filter(function (item) { return item.questionClassificationId == classification.id; })[0].classificationCount" :step="1" icon-inc="expand_less" icon-dec="expand_more" />
              </div>
            </div>            
          </div>
        </div>

        <vs-divider class="mb-6 pt-0">Quiz Image</vs-divider>

        <div class="vx-col w-1/3 mx-auto self-center filepondwidthforquizandquestions">
          <file-pond
            v-show="true"
            id="quiz-filepond"
            ref="quizPagePond"
            :server="uploadLocation"
            label-idle="Drop Quiz Image file here or <span class='filepond--label-action' text-decoration-color: #aaa>Browse</span>"
            accepted-file-types="image/*"
            :allow-multiple="false"
            allowPaste=false
            :instant-upload="true"
            @processfile="uploadCompleteQuiz"
            @removefile="fileRemovedQuiz"
          />
        </div>

        <div class="vx-row ">
          <div class="vx-col sm:w-2/3 w-full mb-2 mx-auto">
            <div v-show="formData.imageUrl">
              <vs-table ref="imageUploadTable" single max-items="5" :data="uploadedImage">
                <template slot-scope="{data}">
                  <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
                    <vs-td style="width: 40px">
                      <img :src="file.url" width=30px class="product-img" />
                    </vs-td>                 
                    <vs-td>
                      <p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1)  }}</p>                     
                    </vs-td>
                    <vs-td>
                      <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" style="float:right!important"  @click.stop="clearImageUrl"></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>                      
          </div>
        </div>  

        <div v-show="formData.id">
          <vs-divider class="mb-6 pt-0">Questions</vs-divider>
          <vs-table ref="questionTable" class="vs-con-loading__container" single @selected="handleSelectedQuestion" search :data="questions">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
              <div class="flex flex-wrap-reverse items-center">
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                  <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success">
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    <span class="ml-2 text-base text-success">Add New Question</span>
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="showQuestionCard(1)">
                      <span>Multiple Choice (Single Correct Answer)</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="showQuestionCard(2)">
                      <span>Multiple Choice (Multiple Correct Answers)</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="showQuestionCard(3)">
                      <span>Free Text</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="showQuestionCard(4)">
                      <span>Table</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="showQuestionCard(5)">
                      <span>Drag And Drop</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="showQuestionCard(6)">
                      <span>Upload</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th sort-key="number">Nr</vs-th>
              <vs-th sort-key="title">Title</vs-th>
              <vs-th sort-key="score">Score</vs-th>
              <vs-th sort-key="classification">Classification</vs-th>
              <vs-th sort-key="modifiedOn">Modified On</vs-th>
              <vs-th sort-key="modifiedOn">Modified By</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="question" :key="indextr" v-for="(question, indextr) in data">

                <vs-td class="quiz-list-image-width">
                  <img src="../../assets/images/MultipleChoiceSingleAnswer.png" width=50px class="product-img" v-show="question.quizQuestionTypeId == 1" />
                  <img src="../../assets/images/MultipleChoiceMultipleAnswers.png" width=50px class="product-img" v-show="question.quizQuestionTypeId == 2" />
                  <img src="../../assets/images/freetext.png" width=50px class="product-img" v-show="question.quizQuestionTypeId == 3" />
                  <img src="../../assets/images/table.png" width=50px class="product-img" v-show="question.quizQuestionTypeId == 4" />
                  <img src="../../assets/images/DragAndDrop.png" width=50px class="product-img" v-show="question.quizQuestionTypeId == 5" />
                  <img src="../../assets/images/upload.png" width=50px class="product-img" v-show="question.quizQuestionTypeId == 6" />
                </vs-td>

                <vs-td :data="data[indextr].number">
                  {{ question.number }}
                </vs-td>

                <vs-td :data="data[indextr].title">
                  {{ question.title }}
                </vs-td>

                <vs-td :data="data[indextr].score">
                  {{ question.score == 0 ? 'N/A' : question.score }}
                </vs-td>

                <vs-td :data="data[indextr].classification">
                  {{ question.questionClassificationName ? question.questionClassificationName : 'None' }}
                </vs-td>

                <vs-td :data="data[indextr].modifiedOn">
                  {{ question.modifiedOn.replace("T", " ").split('.')[0] }}
                </vs-td>

                <vs-td :data="data[indextr].modiefiedBy">
                  {{ question.modifiedBy }}
                </vs-td>

                <vs-td>
                  <div class="flex">
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="right" icon="icon-arrow-up" :disabled="indextr == 0" @click.stop="moveQuestionUp(question.number)"></vs-button>
                    <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="left" icon="icon-arrow-down" :disabled="indextr == data.length - 1" @click.stop="moveQuestionDown(question.number)"></vs-button>
                  </div>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col mt-3">
            <div v-show="!defaultButtonsHidden">
              <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditQuiz" ref="saveEditButton">Save</vs-button>
              <vs-button color="danger" v-show="formData.id" class="mr-5 mb-2 vs-con-loading__container" @click.prevent="validateDelete" ref="deleteButton">Delete</vs-button>
              <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#quizInfoCard'" @click="cancelAdd">Cancel</vs-button>
            </div>
            <div v-show="defaultButtonsHidden">
              <vs-button color="success" class="mb-2" v-scroll-to="'#quizInfoCard'" @click="cancelAdd">Close</vs-button>
            </div>
          </div>
        </div>
      </vx-card>
    </div>

    <multiple-Choice-Single-Answer  :isCardActive="multipleChoiceSingleAnswer"
                                    @closeCard="cardClosed"
                                    :questionSelected="selectedQuestion"
                                    :sourceQuizId="sourceQuizId"
                                    @saveData="dataSaved"
                                    :sourceQuizGradeType="sourceQuizGradeType"
                                    :numberOfQuestions="numberOfQuestions"
                                    :questionCardTitle="questionCardTitle"
                                    :questionClassifications="questionClassifications"
                                    @handleSelectedQuiz="handleSelectedQuiz"/>

    <multiple-Choice-Multiple-Answers   :isCardActive="multipleChoiceMultipleAnswers"
                                        @closeCard="cardClosed"
                                        :questionSelected="selectedQuestion"
                                        :sourceQuizId="sourceQuizId"
                                        @saveData="dataSaved"
                                        :sourceQuizGradeType="sourceQuizGradeType"
                                        :numberOfQuestions="numberOfQuestions"
                                        :questionCardTitle="questionCardTitle"
                                        :questionClassifications="questionClassifications"
                                        @handleSelectedQuiz="handleSelectedQuiz"/>

    <free-Text  :isCardActive="freeText"
                @closeCard="cardClosed"
                :questionSelected="selectedQuestion"
                :sourceQuizId="sourceQuizId"
                @saveData="dataSaved"
                :sourceQuizGradeType="sourceQuizGradeType"
                :numberOfQuestions="numberOfQuestions"
                :questionCardTitle="questionCardTitle"
                :questionClassifications="questionClassifications"
                @handleSelectedQuiz="handleSelectedQuiz"/>

    <table-type :isCardActive="tableType"
                @closeCard="cardClosed"
                :questionSelected="selectedQuestion"
                :sourceQuizId="sourceQuizId"
                @saveData="dataSaved"
                :sourceQuizGradeType="sourceQuizGradeType"
                :numberOfQuestions="numberOfQuestions"
                :questionCardTitle="questionCardTitle"
                :questionClassifications="questionClassifications"
                @handleSelectedQuiz="handleSelectedQuiz"/>

    <drag-and-drop :isCardActive="dragAndDrop"
                @closeCard="cardClosed"
                :questionSelected="selectedQuestion"
                :sourceQuizId="sourceQuizId"
                @saveData="dataSaved"
                :sourceQuizGradeType="sourceQuizGradeType"
                :numberOfQuestions="numberOfQuestions"
                :questionCardTitle="questionCardTitle"
                :questionClassifications="questionClassifications"
                @handleSelectedQuiz="handleSelectedQuiz"/>

    <upload :isCardActive="upload"
            @closeCard="cardClosed"
            :questionSelected="selectedQuestion"
            :sourceQuizId="sourceQuizId"
            @saveData="dataSaved"
            :sourceQuizGradeType="sourceQuizGradeType"
            :numberOfQuestions="numberOfQuestions"
            :questionCardTitle="questionCardTitle"
            :questionClassifications="questionClassifications"
            @handleSelectedQuiz="handleSelectedQuiz"/>

  </div>

</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';

  import multipleChoiceSingleAnswer from './QuizMultipleChoiceSingleAnswer.vue';
  import multipleChoiceMultipleAnswers from './QuizMultipleChoiceMultipleAnswers.vue';
  import freeText from './QuizFreeText.vue';
  import tableType from './QuizTable.vue';
  import dragAndDrop from './QuizDragAndDrop.vue';
  import upload from './QuizUpload.vue';

  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

  export default {
    components: {
      quillEditor,
      multipleChoiceSingleAnswer,
      multipleChoiceMultipleAnswers,
      freeText,
      FilePond,
      tableType,
      dragAndDrop,
      upload
    },
    data() {
      return {
        editorOption: {
          modules: {
            toolbar: 
            [
              ['bold', 'italic', 'underline', 'strike'],        
              ['blockquote', 'code-block'],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'color': [] }, { 'background': [] }],         

              ['clean']  
            ]
          },
        },
        multipleChoiceSingleAnswer: false,
        multipleChoiceMultipleAnswers: false,
        freeText: false,
        tableType: false,
        dragAndDrop: false,
        upload:false,
        sourceQuizId: 0,
        sourceQuizGradeType: "",
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 6,
        isMounted: false,
        isInfoHidden: true,
        isQuizListHidden: false,
        isQuestionCardHidden: true,
        quizzes: [],
        questions: [],
        formData: {
          id: 0,
          name: "",
          title: "",
          description: "",
          isGraded: false,
          passPercentage: 0,
          gradeType: "",
          timeLimit: 0,
          questionClassifications: [],
          questionClassificationCounts: [],
          isJournal: false,
          answerRequired: false,
          imageUrl: null,
        },
        selectedQuestion: {},
        optionNumber: 1,
        numberOfQuestions: 0,
        mode: "",
        defaultButtonsHidden: false,
        questionCardTitle: "",
        questionClassifications: [],
        randomize: false,
        temp: 0,
        uploadedImage: [],
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.quizTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.name);
      },
      classifications: function () {
        var self = this;

        var questions = this.questions;
        return  questions.reduce((prev, curr) => {
          if (prev[curr.questionClassificationId] && prev[curr.questionClassificationId].max > 0) 
            prev[curr.questionClassificationId].max++;
          else
            prev[curr.questionClassificationId] = {id: curr.questionClassificationId, className: curr.questionClassificationName, max : 1 };
            return prev;
        }, {});
      },
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    methods: {
      initQuestionCard(id, quizQuestionTypeId, mode, quizType) {
        if (quizQuestionTypeId == 1){
          this.questionCardTitle = mode == "Add" ? "New Multiple Choice Question (Single Answer)" : "Edit Multiple Choice Question (Single Answer)";
          this.multipleChoiceSingleAnswer = true;
        }
        else if (quizQuestionTypeId == 2){
          this.questionCardTitle = mode == "Add" ? "New Multiple Choice Question (Multiple Answers)" : "Edit Multiple Choice Question (Multiple Answers)";
          this.multipleChoiceMultipleAnswers = true;
        }
        else if (quizQuestionTypeId == 3){
          this.questionCardTitle = mode == "Add" ? "New Text Question" : "Edit Text Question";
          this.freeText = true;
        }
        else if (quizQuestionTypeId == 4){
          this.questionCardTitle = mode == "Add" ? "New Table Question" : "Edit Table Question";
          this.tableType = true;
        }
        else if (quizQuestionTypeId == 5){
          this.questionCardTitle = mode == "Add" ? "New Drag And Drop Question" : "Edit Drag And Drop Question";
          this.dragAndDrop = true;
        }
        else if (quizQuestionTypeId == 6){
          this.questionCardTitle = mode == "Add" ? "New Upload Question" : "Edit Upload Question";
          this.upload = true;
        }

        if(mode == "Add")
          this.selectedQuestion = {};

        if(!isNaN(id))
          this.sourceQuizId = id;
        
        this.sourceQuizGradeType = quizType;
      },
      cardClosed() {
        var self = this;
        self.multipleChoiceSingleAnswer = false;
        self.multipleChoiceMultipleAnswers = false;
        self.freeText = false;
        self.tableType = false;
        self.dragAndDrop = false;
        self.upload = false;

        self.loadQuestions();
      },
      initQuizValues() {
        this.formData.id = 0;
        this.formData.name = "";
        this.formData.title = "";
        this.formData.description = "";
        this.formData.gradeType = "graded";
        this.formData.answerRequired = false;
        this.formData.passPercentage = 50;
        this.formData.timeLimit = 0;
        this.formData.imageUrl = null;
        this.formData.uploadedImage = [];
        this.formData.questionClassifications = [];
        this.formData.questionClassificationCounts = [];
        this.numberOfQuestions = 0;
        this.formData.isJournal = false;
        this.mode = "";
        this.errors.clear();
        this.uploadedImage = [];
        this.$refs.quizPagePond.removeFiles();
      },
      cancelAdd() {
        this.initQuizValues();
        this.isInfoHidden = true;
        this.isQuizListHidden = false;
      },
      saveData() {
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      dataSaved(){
        this.getQuestionClassifications();
        this.multipleChoiceSingleAnswer = false;
        this.multipleChoiceMultipleAnswers = false;
        this.freeText = false;
        this.tableType = false;
        this.dragAndDrop = false;
        this.upload = false;
        this.loadQuestions();
      },
      loadData() {
        const self = this;
        self.showLoadingOnTable();

        var onSuccess = function (response) {
          self.quizzes = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.quizTable.$el);
          self.$refs.quizTable.searchx = "";
        };

        self.$ajaxGet(self, "quiz/ListQuizzes", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.errors.clear();
        self.initQuizValues();
        self.questions = [];
        self.isQuizListHidden = true;
        self.isInfoHidden = false;
        self.defaultButtonsHidden = false;
        self.mode = "Add New";
      },
      getQuestionClassifications() {
        const self = this;
        var onSuccess = response => {
          self.questionClassifications = response.data.map((item) => {return {label: item.text, value: item.value} });
        };
        self.$ajaxGet(self, "Question/getQuestionClassifications", onSuccess);
      },
      handleSelectedQuiz(quiz) {
        var self = this;
        self.defaultButtonsHidden = false;
        self.isQuizListHidden = true;
        self.isInfoHidden = false;
        self.mode = "Update"
        self.scrollToNavbar();
        self.formData.id = quiz.id;
        self.loadQuizData();
        self.loadQuestions();
        self.formData.name = quiz.name;
        self.formData.title = quiz.title;
        self.formData.description = quiz.description;
        self.formData.gradeType = quiz.isGraded ? "graded" : "survey";
        self.formData.passPercentage = quiz.passPercentage;
        self.formData.timeLimit = quiz.timeLimit;
        self.formData.questionClassifications = quiz.questionClassifications;
        self.formData.questionClassificationCounts = quiz.questionClassificationCounts;
        self.formData.randomize = quiz.randomize;
        self.randomize = quiz.randomize;
        self.formData.isJournal = quiz.isJournal;
        self.formData.answerRequired = quiz.answerRequired && quiz.answerRequired != null  ? true : false;
        self.formData.imageUrl = quiz.imageUrl;

        if(self.formData.imageUrl){
          this.uploadedImage = [];
          this.uploadedImage.push({
            url: self.formData.imageUrl,        
          })
        }
      },
      saveEditQuiz() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnSaveButton();
            self.formData.isGraded = self.formData.gradeType == "graded" ? true : false;
            if(self.formData.isJournal){
              self.formData.questionClassifications = [];
              self.formData.questionClassificationCounts = [];
              self.randomize = false;
            }

            var onSuccess = response => {
              self.formData.id = response.data;
              self.saveData();
              self.scrollToNavbar();
              if(self.mode != "Add New"){
                self.isInfoHidden = true;
                self.initQuizValues();
                self.isQuizListHidden = false;
              }else{
                self.defaultButtonsHidden = true;
                self.getQuestionClassifications();
              }

              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Quiz Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };

            self.formData.randomize = self.randomize;

            self.$ajaxPost(self, "quiz/addeditquiz", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      validateDelete() {
        if(this.questions.length > 0)
          this.openConfirm();
        else
          this.deleteQuiz();
      },
      openConfirm() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Attention`,
          text: 'Are you sure you want to delete the selected quiz and ALL of its associated questions? \n\nNote: This cannot be undone.',
          accept: this.deleteQuiz,
          acceptText: "Yes, delete",
          cancelText: "No, cancel"
        })
      },
      deleteQuiz() {
        var self = this;
        self.showLoadingOnDeleteButton();

        var onSuccess = response => {
          self.saveData();
          self.initQuizValues();
          self.errors.clear();
          self.isQuizListHidden = false;
          self.isInfoHidden = true;
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Quiz Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };

        self.$ajaxDelete(self, "quiz/" + self.formData.id, onSuccess, onFinally);
      },
      handleSelectedQuestion(question){
        var self = this;
        self.selectedQuestion = question;
        self.errors.clear();
        self.scrollToNavbar();
        self.initQuestionCard(self.formData.id, question.quizQuestionTypeId, "Edit", self.formData.gradeType);
      },
      showQuestionCard(questionType){
        var self = this;
        self.errors.clear();
        self.scrollToNavbar();
        self.initQuestionCard(self.formData.id, questionType, "Add", self.formData.gradeType);
      },
      loadQuestions(){
        const self = this;
        self.$vs.loading.close(self.$refs.questionTable.$el);
        self.showLoadingOnQuestionsTable();

        var onSuccess = function (response) {
          self.questions = response.data;
          self.numberOfQuestions = self.questions.length;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.questionTable.$el);
          self.$refs.questionTable.searchx = "";
        };

        self.$ajaxGet(self, "Question/ListQuestions?quizId=" + self.formData.id, onSuccess, onFinally);
      },
      loadQuizData(){
        const self = this;

        self.showLoadingOnQuizInfoCard();

        var onSuccess = function (response) {

            self.formData.name = response.data.name;
            self.formData.title = response.data.title;
            self.formData.description = response.data.description;
            self.formData.gradeType = response.data.isGraded ? "graded" : "survey";
            self.formData.passPercentage = response.data.passPercentage;
            self.formData.timeLimit = response.data.timeLimit;
            self.formData.questionClassifications = response.data.questionClassifications;
            self.formData.questionClassificationCounts = response.data.questionClassificationCounts;
            self.formData.randomize = response.data.randomize;
            self.randomize = response.data.randomize;
            self.formData.isJournal = response.data.isJournal;
            self.formData.answerRequired = response.data.answerRequired && response.data.answerRequired != null  ? true : false;
            self.formData.imageUrl = response.data.imageUrl;

            if(self.formData.imageUrl){
              self.uploadedImage = [];
              self.uploadedImage.push({
                url: self.formData.imageUrl,        
              })
        }


        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.quizInfo.$el);
        };

        self.$ajaxGet(self, "Quiz/GetQuizData?quizId=" + self.formData.id, onSuccess, onFinally);
      },
      moveQuestionUp(questionNumber){
        var self = this;
        self.showLoadingOnQuestionsTable();

        var onSuccess = function (response) {
          self.loadQuestions();
        };

        self.$ajaxGet(self, "Question/MoveUp?quizId=" + self.formData.id + "&index=" + questionNumber, onSuccess);
      },
      moveQuestionDown(questionNumber){
        var self = this;
        self.showLoadingOnQuestionsTable();

        var onSuccess = function (response) {
          self.loadQuestions();
        };

        self.$ajaxGet(self, "Question/MoveDown?quizId=" + self.formData.id + "&index=" + questionNumber, onSuccess);
      },
      showLoadingOnSaveButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveEditButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnSaveQuestionButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveQuestionButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.quizTable.$el,
          scale: 1
        });
      },
      showLoadingOnQuestionsTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.questionTable.$el,
          scale: 1
        });
      },
      showLoadingOnQuizInfoCard(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.quizInfo.$el,
          scale: 1
        });
      },
      showLoadingOnDeleteButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.deleteButton.$el,
          scale: 0.45
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },

      uploadCompleteQuiz(error, file) {
        var response = JSON.parse(file.serverId);
        if(response.url)
          this.uploadedImage = [];
          this.formData.imageUrl = response.url;
          this.uploadedImage.push({
            url: response.url,        
          })
      },
      fileRemovedQuiz(error, file) {
        this.formData.imageUrl = null;
      },
      clearImageUrl() {
        this.uploadedImage = [];
        this.formData.imageUrl = null;
      },
    },
    mounted() {     
      var self = this;
      self.loadData();
      self.getQuestionClassifications();
      self.isMounted = true;

      if(this.$route.path == "/digi/quizzes")
        this.$store.dispatch("updateTheme", "dark");
    },
  }

</script>

<style lang="scss">
@import "@/digicampus/assets/main-digi.scss";

.numberinput{
  background: #ffffff;
  float: left;
}

// .vs-textarea {
//   border: 1px solid #c2c6dc !important;
// }

#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;
        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;
          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;
        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.quiz-list-image-width{
  width: 50px;
}

</style>
